/**
 * Created by amirb on 6/2/16.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.App = window.App || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var ImageParsingHelper = require('web-agent-adapters/ImageParsingHelper');
    var imageParsingHelper;
    var MAX_FILE_SIZE = 5,
        MAX_RETRY_COUNT = 2,
        RETRY_TIMEOUT = 1000, // Wait 1 second between each timeout
        ERROR_TYPES = {
            TYPE: 'TYPE',
            SIZE: 'SIZE'
        },
        ALLOWED_EXTENSIONS = ['PNG', 'JPG', 'GIF', 'JPEG'];

    var linesHandler = {};
    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var fileSharingModel;
    var amsClient;
    var logger;
    var urlExpirationMap = {};

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    var fileSharingController = BaseController.extend(function fileSharingController(options) {

        logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        if (options) {
            _setModel(options.model);
            _setClient(options.client);
        }
        if (fileSharingModel) {
            // Set binds here
        }

        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onEventNotification, this.onEventNotification.bind(this));
        imageParsingHelper = new ImageParsingHelper();

    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    fileSharingController.prototype.applicationType = 'fileSharingController';

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * Adds AMS-client callbacks to the settings object
     * @param settings The object we add the callbacks to
     */
    fileSharingController.prototype.addClientCallbacks = function (settings) {
        settings.onEventNotification = {func: this.onEventNotification, context: this};
    };

    fileSharingController.prototype.setClient = function (client) {
        _setClient(client);
    };

    fileSharingController.prototype.onEventNotification = function (client) {
    };


    fileSharingController.prototype.getDownloadUrl = function (data) {
        var _data = data;
        var currentIndex;
        var conversationId = data.conversationId;
        var latestAgentId = data.latestAgentId;
        var doneHandler = data.done;
        var lastUrl = data.lastUrl;
        var fileId = _getFileId(data);
        var isHistory = data.isHistory;
        var isAudio = data.isAudio || false;
        var imageURL;

        data.success = function(data){
            var imageObj;

            if(!isAudio) {
                currentIndex = !_data.index && _data.index !== 0 ? _getImageIndex(_data) : _data.index;
                imageObj = lpUtils.cloneObject(fileSharingModel.get('images.' + conversationId + '.' + currentIndex));
            } else {
                currentIndex = !_data.index && _data.index !== 0 ? _getAudioIndex(_data) : _data.index;
                imageObj = lpUtils.cloneObject(fileSharingModel.get('audio.' + conversationId + '.' + currentIndex));
            }

            if (!imageObj || !imageObj.event || !imageObj.event.message) {
                if(!imageObj.event && !imageObj.message){
                    return;
                }
               if(imageObj.message){
                   imageObj.event = {
                       message: imageObj.message
                   };
               }
            }


            if(isHistory){
                imageURL =  data.body;
            }else{
                imageURL =  _buildUrl(data);
            }

            imageObj.event.message.imageUrl = imageURL;

            if(!isAudio) {
                fileSharingModel.modify('images.' + conversationId , [imageObj], 'id');
            } else {
                fileSharingModel.modify('audio.' + conversationId , [imageObj], 'id');
            }

            if (typeof doneHandler == 'function') {
                doneHandler({
                    url: imageURL,
                    conversationId: conversationId
                });
            }

        };

        data.error = function(data){
            //add error handler
        };

        if(isHistory){
            data.data =  {
                conversationId :conversationId,
                latestAgentId: latestAgentId,
                fileId:fileId
            };

            data.searchType = 'photoSharingGetUrl';
            lpTag.WebAgent.amsEngagementHistoryController.service.photoSharingGetUrl(data);
        }else{
            if (!lastUrl || _isUrlTimeExpired(lastUrl)) {

                lpTag.WebAgent.amsConnectionController.amsClient.imageMessage(data);

            } else if (typeof doneHandler == 'function') {
                doneHandler({
                    url: lastUrl,
                    conversationId: conversationId
                });
            }
        }




        function  _getFileId(data){
            var str = data.pathUrl;
            var index = str.lastIndexOf("/");
            return str.substring(index+1);
        }
    };

    fileSharingController.prototype.getValidFileExtensions = function() {
        return lpUtils.cloneArray(ALLOWED_EXTENSIONS);
    };

    fileSharingController.prototype.getFileUploadErrorTypes = function() {
        return lpUtils.cloneObject(ERROR_TYPES);
    };

    fileSharingController.prototype.getFileUploadSizeLimit = function() {
        return MAX_FILE_SIZE;
    };

    fileSharingController.prototype.onFileSelected = function (data) {
        if (data && data.file) {
            var details = _getFileDetails(data);
            if (_isFileTypeValid.call(this, details.fileType, data)) {
                switch (details.fileType) {
                    case 'JPG':
                    case 'JPEG':
                    case 'PNG':
                    case 'GIF':
                        imageParsingHelper.fixOrientation(data.file, _showFilePreview.bind(this, data));
                        break;
                    default:
                        if (_isFileValid.call(this, details, data)) {
                            _showFilePreview.call(this, data, data.file);
                        }
                        break;
                }
            }
        }
    };

    fileSharingController.prototype.sendFile = function(data) {
        if(!data || !data.file) {
            return;
        }

        var file = data.file;

        var selectedFileDetails = _getFileDetails(data);

        if(_isFileValid.call(this, selectedFileDetails, data)){
            selectedFileDetails.error = selectedFileDetails.success = _fetchGenerateUrlResponse.bind(this, file, selectedFileDetails);
            lpTag.WebAgent.amsConnectionController.amsClient.generateURLForUploadFile(selectedFileDetails);
        }
    };

    fileSharingController.prototype.retryUploadFile = function (data) {
        if (data && data.id && linesHandler && linesHandler[data.id] && linesHandler[data.id].retry) {
            linesHandler[data.id].retry(0);
        }
    };


    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    /**
     * Sets the model
     * @param model - the model
     * @private
     */
    function _setModel(model) {
        if (model) {
            fileSharingModel = model;
        }
    }

    function _buildUrl(data) {
        var expires = (data && data.queryParams && data.queryParams.temp_url_expires) || 1;
        var sig = (data && data.queryParams && data.queryParams.temp_url_sig) || '';
        var urlExpirationTime = expires * 1000;
        var url = agentLEManager.getLEUrlResolverGetUrl('{swift}');
        url += data.relativePath;
        url += '?temp_url_sig=' + sig;
        url += '&temp_url_expires=' + expires;
        urlExpirationMap[url] = urlExpirationTime;

        return url;
    }

    function _isUrlTimeExpired(url) {
        var currentTime = lpTag.WebAgent.amsController.getServerTime();
        if (!urlExpirationMap[url]) {
            return true;
        }

        return urlExpirationMap[url] <= currentTime;
    }

    function _setClient(client) {
        if (client) {
            amsClient = client;
        }
    }

    function _getImageIndex(data){
       var imagesArray = fileSharingModel.get('images.' + data.conversationId ) || [];
//       var imagesArray = photosSharingModel.get('chats.' + data.conversationId +'.chatInfo.events.images') || [];
       return _.findIndex( imagesArray, function(item) { return item.id == data.id; });
    }

    function _getAudioIndex(data){
        var audioArray = fileSharingModel.get('audio.' + data.conversationId ) || [];
        return _.findIndex( audioArray, function(item) { return item.id == data.id; });
    }

    function _showFilePreview(data, file) {
        window.App.viewEventsHandler.fireEvent({
            appName: data.visitorId,
            UIEvent: window.App.viewEventsHandler.eventType.SHOW_FILE_UPLOAD_PREVIEW,
            eventData: {file: file, name: data.file.name, callback: data.callback},
            deleteOnFire: true
        });
    }

    function _getFileDetails(data) {
        var file = (data && data.file) || {};
        var size = file.size || '';

        return {
            chatId: data.chatId,
            visitorId: data.visitorId,
            fileSize: size.toString(),
            fileType: _typeToFileType(file.type),
            doneCallback: data.callback,
            caption: data.caption || ''
        };
    }

    function _typeToFileType(type) {
        if (!type) {
            return false;
        }
        var fileType = type;
        if (fileType.indexOf('\/') > -1) {
            fileType = fileType.split('\/')[1];
        }
        return fileType.toUpperCase();
    }

    function _isFileTypeValid(type, data) {
        if ((!type || type.length > 4) && data && data.file && data.file.name) {
            var name = data.file.name.split('.');
            type = _typeToFileType(name[name.length - 1]);
        }
        var isBlob = data && data.file && data.file instanceof Blob;
        var isValid = isBlob && !!type && this.getValidFileExtensions().indexOf(type) >= 0;
        if (!isValid) {
            window.App.viewEventsHandler.fireEvent({
                appName: data.visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.SHOW_FILE_UPLOAD_ERROR,
                eventData: {errorType: this.getFileUploadErrorTypes().TYPE, fileType: type},
                deleteOnFire: true
            });
            if (data.callback && typeof data.callback === 'function') {
                // This is the callback for the custom widget. Here we want to send an informative error message.
                var message = 'Invalid file type: ' + type;
                if (!type) {
                    message = 'Not a file. You need to send a File (from a file input) or a Blob. You can do this using an xhr request.';
                }
                data.callback(message);
            }
        }
        return isValid;
    }

    function _isFileValid(fileDetails, data) {
        var isValid = true,
            fileSize = fileDetails.fileSize / 1024 / 1024;

        if (!_isFileTypeValid.call(this, fileDetails.fileType, data)) {
            isValid = false;
        } else  if (fileSize > this.getFileUploadSizeLimit()) {
            isValid = false;
            window.App.viewEventsHandler.fireEvent({
                appName: data.visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.SHOW_FILE_UPLOAD_ERROR,
                eventData: {errorType: this.getFileUploadErrorTypes().SIZE},
                deleteOnFire: true
            });
        }
        return isValid;
    }

    function _checkSwiftUploadData(swiftUploadData) {
        var uploadData = swiftUploadData;
        if (typeof swiftUploadData === 'string') {
            uploadData = {
                error: swiftUploadData
            };
        }
        if (swiftUploadData.timeout) {
            uploadData = {
                error: swiftUploadData.timeout
            };
        }
        return uploadData;
    }

    /**
     * get's the response from UMS generateUploadURL and parse it in order to upload the file to Swift.
     * @param selectedFile
     * @param selectedFileDetails
     * @param swiftUploadData
     * @private
     */
    function _fetchGenerateUrlResponse(selectedFile, selectedFileDetails, swiftUploadData) {
        var uploadData = _checkSwiftUploadData(swiftUploadData);

        var createLineCB = _createLine.bind(this, selectedFile, selectedFileDetails, uploadData);
        _createThumbnail(selectedFile, createLineCB);
    }

    /**
     * create the image thumbnail
     * @param selectedImage
     * @param callback
     * @private
     */
    function _createThumbnail(selectedImage, callback) {
        imageParsingHelper.createThumbnail(selectedImage, callback);
    }

    /**
     * create the line to send to UMS
     * first create the local line, then upload the file to swift and send the line to UMS.
     * @param selectedFile
     * @param selectedFileDetails
     * @param swiftUploadData
     * @param thumbnail
     * @private
     */
    function _createLine(selectedFile, selectedFileDetails, swiftUploadData, thumbnail) {
        var line = {
            event: {
                contentType: lpAMSController.CONTENT_TYPES.HOSTED_FILE,
                type: lpTag.AMSStatics.eventTypes.CONTENT,
                message: {
                    preview: thumbnail,
                    caption: selectedFileDetails.caption,
                    fileType: selectedFileDetails.fileType,
                    relativePath: swiftUploadData.relativePath
                },
            },
            text: selectedFileDetails.caption,
            chatId: selectedFileDetails.chatId,
            contentType: lpAMSController.CONTENT_TYPES.HOSTED_FILE,
            type: 'line',
            by: this.model.get('agent.agentName'),
            fileType: selectedFileDetails.fileType,
            doneCallback: selectedFileDetails.doneCallback,
            isImage: true
        };

        // Show the line in the UI.
        // the callback gets the lineHandler (the actual function that sends the line to the server) and the local line index in order to track the specific line.
        // lineHandler.callback is the real callback that fires the request to UMS with the thumbnail after
        var lineHandlerCallback = _lineHandlerCallback.bind(this, selectedFile, selectedFileDetails, swiftUploadData);
        var dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(line.chatId);
        if (!dialogId) {
            var campaignInfo;
            var engagementId = fileSharingModel.get('chats.' + selectedFileDetails.chatId + '.chatInfo.engagementId');
            var campaignId   = fileSharingModel.get('chats.' + selectedFileDetails.chatId + '.chatInfo.campaignId');
            if(engagementId && campaignId){
                campaignInfo = {
                    engagementId: engagementId,
                    campaignId: campaignId
                };
            }
            line.textValue = line.text;
            // There is no current active conversation, so we can't just send the line. We need to resume first.
            lpTag.WebAgent.AppMediator.createConversation({
                conversationId: line.chatId,
                originContext: fileSharingModel.get('chats.' + selectedFileDetails.chatId + '.chatInfo.originContext'),
                consumerId: selectedFileDetails.visitorId,
                skillId: fileSharingModel.get('chats.' + selectedFileDetails.chatId + '.chatInfo.skillIds') || '-1',
                campaignInfo: campaignInfo,
                agentName: line.by,
                // error: function (errorData) {
                // },
                context: this,
                newChatLine: line
            }, lineHandlerCallback);
        } else {
            lpTag.WebAgent.AppMediator.addLine(line, lineHandlerCallback);
        }
    }

    function _lineHandlerCallback(selectedFile, selectedFileDetails, swiftUploadData, lineHandler) {
        if (lineHandler && lineHandler.id && !linesHandler[lineHandler.id]) {
            linesHandler[lineHandler.id] = {
                send: lineHandler.callback,
                error: lineHandler.error,
                lineRetry: lineHandler.retry,
                retry: _retryUploadFile.bind(this,  selectedFile, lineHandler.id),
                details: selectedFileDetails
            };

            if (lineHandler.id.startsWith('undefined')) {
                // This means there's no dialog ID - so the conversation was closed before we sent the file. Show error
                // with no retry
                _setLinesLoaders(lineHandler.id, true, false, false);
            } else if (swiftUploadData.error) {
                // There was an error generating an upload URL. Show error with retry
                _setLinesLoaders(lineHandler.id,  true, false, true);
            } else {
                // No error. Show loader and prepare to upload.
                _setLinesLoaders(lineHandler.id, false, true);
                _prepareToUpload.call(this, selectedFile, lineHandler.id, swiftUploadData);
            }
        }
    }

    /**
     * trigger an event for individual line to show/hide the loader
     * @param lineId
     * @param isError
     * @param showLoader
     * @param canRetry
     * @private
     */
    function _setLinesLoaders(lineId, isError, showLoader, canRetry) {
        window.App.viewEventsHandler.fireEvent({
            appName: lineId,
            UIEvent: window.App.viewEventsHandler.eventType.SHOW_FILE_UPLOAD_ERROR,
            eventData: {
                showLoader: showLoader,
                error: isError,
                canRetry: canRetry
            }
        });
    }

    /**
     * prepare the file to upload, convert it to byte array and send to _uploadFile
     * @param selectedFile
     * @param lineId
     * @param swiftUploadData
     * @param retryCount
     * @private
     */
    function _prepareToUpload(selectedFile, lineId, swiftUploadData, retryCount) {
        if (linesHandler[lineId]) {
            if (!swiftUploadData.error) {
                var selectedFileDetails = linesHandler[lineId].details;
                var uploadUrl = _buildUrl(swiftUploadData);
                if (selectedFile && selectedFileDetails && uploadUrl) {

                    var reader = new FileReader();

                    reader.onload = function () {
                        var arrayBuffer = this.result,
                            array = new Int8Array(arrayBuffer);

                        _uploadFile(selectedFile, array, uploadUrl, _linesStateHandler.bind(this, lineId, retryCount || 0, swiftUploadData));
                    };

                    reader.readAsArrayBuffer(selectedFile);
                }
            } else {
                _setLinesLoaders(lineId, true, false, true);
            }
        }
    }

    /**
     * called after the file upload to Swift finished, send the line to UMS and hides the line loader
     * @param lineId
     * @param retryCount
     * @param isSuccess
     * @param canRetry
     * @private
     */
    function _linesStateHandler(lineId, retryCount, swiftUploadData, isSuccess, canRetry) {
        if (linesHandler[lineId] && isSuccess && linesHandler[lineId].send) {
            linesHandler[lineId].send(swiftUploadData && swiftUploadData.relativePath);
        }
        else if (!isSuccess) {
            retryCount = retryCount || 0;
            if (canRetry && retryCount < MAX_RETRY_COUNT) {
                retryCount++;
                setTimeout(function () {
                    if (linesHandler[lineId] && linesHandler[lineId].retry) {
                        linesHandler[lineId].retry(retryCount);
                    } else {
                        _setLinesLoaders(lineId, !isSuccess, false, canRetry);
                    }
                }, RETRY_TIMEOUT);
                return;
            } else if (linesHandler[lineId] && linesHandler[lineId].error){
                linesHandler[lineId].error({canRetry: canRetry});
            }
        }
    }

    function _retryUploadFile(selectedFile, lineId, retryCount) {
        if (linesHandler[lineId].lineRetry) {
            linesHandler[lineId].lineRetry();
        }
        _setLinesLoaders(lineId, false, true, true);
        var selectedFileDetails = linesHandler[lineId].details;
        retryCount = retryCount || 0;
        selectedFileDetails.error = selectedFileDetails.success = _retryUploadGenerateUrlResponse.bind(this, selectedFile, lineId, retryCount);
        lpTag.WebAgent.amsConnectionController.amsClient.generateURLForUploadFile(selectedFileDetails);
    }

    function _retryUploadGenerateUrlResponse(selectedFile, lineId, retryCount, swiftUploadData) {
        var uploadData = _checkSwiftUploadData(swiftUploadData);
        _prepareToUpload.call(this, selectedFile, lineId, uploadData, retryCount);
    }

    function _uploadFile(selectedFile, binaryString, uploadUrl, callback) {
        if (binaryString) {
            var request = new XMLHttpRequest();
            request.open('PUT', uploadUrl);
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    //return true if success
                    callback(request.status === 201, request.status < 400 || request.status >= 500);
                }
            };

            request.send(binaryString);
        }
    }

    return fileSharingController;

});
